module.exports = __webpack_public_path__ + "static/img/gsjs_tu2.0f547c7.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/gsjs_tu2.png
// module id = ceXs
// module chunks = 0